import React, { FC } from 'react'
import { styled } from 'parkdepot-shared/theme'

interface Props {
    lat: number
    lng: number
    id: string
    onMarkerClick?: (lotId: string) => void
}

const Container = styled('div', {
    position: 'absolute',
    transform: 'translate(-50%, -50%)'
})

const PinBody = styled('div', ({ $theme }) => ({
    height: '32px',
    width: '32px',
    backgroundColor: $theme.colors.primary,
    position: 'relative',
    borderRadius: '50% 50% 50% 50%',
    left: '0px',
    top: '-22px'
}))

const PinPoint = styled('div', ({ $theme }) => ({
    position: 'absolute',
    top: '28px',
    left: '-4px',
    width: '0',
    height: '0',
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent',
    borderTop: `10px solid ${$theme.colors.primary}`,
    marginLeft: '10px'
}))

const Icon = styled('i', {
    position: 'absolute',
    margin: 'auto',
    top: '0',
    bottom: '0',
    left: '0',
    right: '0',
    fontSize: '1.8rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff'
})

const Marker: FC<Props> = ({ id, onMarkerClick }) => {
    return (
        <Container>
            <PinBody onClick={() => onMarkerClick?.(id)}>
                <PinPoint />
                <Icon className="wemolo-parking" />
            </PinBody>
        </Container>
    )
}

export default Marker
